<template>
    <div id="notfound">
		<div class="notfound">
			<div>
				<div class="notfound-404">
					<h1>!</h1>
				</div>
				<h2> YETKİSİZ KULLANICI</h2>
			</div>
			<p> Bu sayfayı görtüntüleme yetkiniz yok. Lütfen yöneticiniz ile iletişime geçin. <a href="#">Anasayfaya Geri Dön</a></p>
		</div>
	</div>
</template>
<script>
    export default {
         name: 'Forbidden',
    }
</script>
<style lang="css" scoped> 
    @import "./styles/error.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Error/Forbidden.vue